import PropTypes from "prop-types";
import React, {PureComponent} from "react";
import {connect} from "react-redux";

import {ActionCreator as ApplicationActionCreator} from "../reducers/application/application";
import {ActionCreator as DataActionCreator, Operation} from "../reducers/data/data";
import {AppRoute} from "../const";
import {PeriodDataPropType} from "../prop-types";
import {applyArchive} from "../utils/archive";
import {getActivePeriod, getArchive, getCurrentPeriod, getPeriods} from '../reducers/data/selectors';
import {history} from "../history";


const getPeriodById = (periods, periodId) => {
  return periods.find((period) => period.periodId === periodId) || null;
};

const getArchiveItemTitleByPeriod = (archive, period) => {
  const archiveItem = archive.find((archiveitem) => archiveitem.periods.includes(period.periodId));
  const archiveTitle = archiveItem.periods.length > 1 ? archiveItem.archiveTitle : ``;
  return archiveTitle;
};


class ArchiveComponent extends PureComponent {
  constructor(props) {
    super(props);

    this._applyArchive = this._applyArchive.bind(this);
    this._createArchiveItemTemplate = this._createArchiveItemTemplate.bind(this);
    this._createArchiveLinkTemplate = this._createArchiveLinkTemplate.bind(this);
  }

  componentDidMount() {
    this._applyArchive();
  }

  _applyArchive() {
    applyArchive();
  }

  _handleClick(newPeriodId) {
    this.props.onPeriodChange(newPeriodId, () => {
      const searchRequest = newPeriodId === `` ? `` : `?period=${newPeriodId}`;

      history.push({
        pathname: AppRoute.MAIN,
        search: searchRequest,
      });
    });
  }

  _createArchiveLinkTemplate(period, index, archiveTitle = null) {
    const currentPeriod = this.props.currentPeriod;
    const newPeriod = period.periodId === currentPeriod.periodId ? `` : period.periodId;
    const title = archiveTitle ? archiveTitle : period.archiveTitle;

    return (
      <button
        key={period + index}
        className="archive__link"
        type="button"
        onClick={this._handleClick.bind(this, newPeriod)}
      >
        {title}
      </button>
    );
  }

  _createArchiveItemTemplate(archiveItem, index) {
    const archiveItemTitle = archiveItem.archiveTitle;
    const periodsList = this.props.periods;
    const periods = archiveItem.periods;

    if (periods.length === 1) {
      const periodsLinksTemplate = periods.map((periodId, periodIndex) => this._createArchiveLinkTemplate(getPeriodById(periodsList, periodId), periodIndex, archiveItemTitle));

      return (
        <li key={archiveItem + index} className="archive__item">
          {periodsLinksTemplate}
        </li>
      );
    }

    const periodsLinksTemplate = periods.map((periodId, periodIndex) => this._createArchiveLinkTemplate(getPeriodById(periodsList, periodId), periodIndex));

    return (
      <li key={archiveItem + index} className="archive__item">
        <button className="archive__subbutton" type="button">{archiveItemTitle}</button>

        <ul
          ref={this._archiveSublistRef}
          className="archive__sublist"
        >
          {periodsLinksTemplate.map((linkTemplate, linkIndex) => {
            return (
              <li key={linkTemplate + linkIndex} className="archive__subitem">
                {linkTemplate}
              </li>
            );
          })}
        </ul>
      </li>
    );
  }

  render() {
    const periods = this.props.periods;
    const archive = this.props.archive;
    const currentPeriod = this.props.currentPeriod;
    const activePeriod = this.props.activePeriod;

    const archiveItemTitle = periods && archive ? getArchiveItemTitleByPeriod(archive, activePeriod) : ``;
    const archiveTitle = activePeriod.periodId === currentPeriod.periodId ? `Архив` : `${activePeriod.archiveTitle} ${archiveItemTitle}`;

    if (periods && archive) {
      return (
        <section className="archive">
          <h6 className="visually-hidden">Архив</h6>

          <button
            ref={this._archiveButtonRef}
            className="archive__button"
            type="button"
            onClick={this._handleArchiveButtonClick}
          >
            <span className="archive__icon  icon-archive"></span>
            {archiveTitle}
          </button>

          <ul
            ref={this._archiveListRef}
            className="archive__list"
          >
            {
              archive.map((archiveItem, index) => {
                const archiveItemTemplate = this._createArchiveItemTemplate(archiveItem, index);
                return archiveItemTemplate;
              })
            }
          </ul>
        </section>
      );
    }
    return null;
  }
}


ArchiveComponent.propTypes = {
  periods: PropTypes.arrayOf(PeriodDataPropType),
  archive: PropTypes.arrayOf(PropTypes.shape({
    archiveTitle: PropTypes.string.isRequired,
    periods: PropTypes.arrayOf(PropTypes.string).isRequired,
  })),
  activePeriod: PeriodDataPropType.isRequired,
  currentPeriod: PeriodDataPropType.isRequired,
  onPeriodChange: PropTypes.func.isRequired,
};


const mapStateToProps = (state) => ({
  periods: getPeriods(state),
  archive: getArchive(state),
  activePeriod: getActivePeriod(state),
  currentPeriod: getCurrentPeriod(state),
});

const mapDispatchToProps = (dispatch) => ({
  onPeriodChange(newPeriodId, cb) {
    dispatch(ApplicationActionCreator.setActivePeriod(newPeriodId));
    dispatch(DataActionCreator.setDataError(null));
    dispatch(Operation.loadPools(newPeriodId))
    .then(() => cb());
  },
});

const Archive = connect(mapStateToProps, mapDispatchToProps)(ArchiveComponent);


export {
  ArchiveComponent,
  Archive,
};
